var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.362 49.3515H24.5748L14.0693 59.0587L15.7979 49.3515H4.09581C3.29793 49.3515 2.76602 48.8196 2.76602 48.0217V10.7877C2.76602 9.98978 3.29793 9.45787 4.09581 9.45787H57.2873C58.0852 9.45787 58.6171 9.98978 58.6171 10.7877V36.054H61.2767V10.7877C61.2767 8.52706 59.548 6.79829 57.2873 6.79829H4.09581C1.83521 6.79829 0.106445 8.52697 0.106445 10.7877V48.0217C0.106445 50.2823 1.83513 52.0111 4.09581 52.0111H12.6064L9.94687 66.24L25.6388 52.0111H29.3622L29.362 49.3515Z",
    fill: "#3F8FC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08496 17.4357H53.2977V14.7762H8.08496V17.4357Z",
    fill: "#F27A76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08496 25.4153H53.2977V22.7557H8.08496V25.4153Z",
    fill: "#3F8FC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08496 33.3932H53.2977V30.7336H8.08496V33.3932Z",
    fill: "#F27A76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08496 41.3719H29.4943C29.7603 40.441 30.1592 39.5102 30.6911 38.7123H8.08513L8.08496 41.3719Z",
    fill: "#3F8FC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9045 38.7132H36.0108C33.7503 38.7132 32.0215 40.4419 32.0215 42.7026V69.2983C32.0215 71.5589 33.7502 73.2877 36.0108 73.2877H75.9045C78.1651 73.2877 79.8938 71.559 79.8938 69.2983V42.7026C79.8938 40.442 78.1651 38.7132 75.9045 38.7132ZM77.2342 63.0485L61.9415 54.9369L77.2342 48.6868V63.0485ZM36.0104 41.3728H75.904C76.7019 41.3728 77.2338 41.9047 77.2338 42.7026V45.7611L55.9572 54.5373L34.6806 45.7611V42.7026C34.6806 41.9047 35.2125 41.3728 36.0104 41.3728ZM49.973 54.937L34.6802 63.0487V48.687L49.973 54.937ZM75.904 70.6289H36.0104C35.2125 70.6289 34.6806 70.097 34.6806 69.2992V66.1077L53.1649 56.2677L55.9574 57.4644L58.7499 56.2677L77.2342 66.1077V69.2992C77.2342 70.097 76.7022 70.6289 75.9044 70.6289H75.904Z",
    fill: "#003448"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.8a4726575f139c45e29eb46371ac74c6.svg";
export { ForwardRef as ReactComponent };